import BaseDialog from '../components/dialogs/BaseDialog'
import CzDatePicker from '../components/CzDatePicker'

export default {
    components: {
        CzDatePicker,
        'BaseDialog': BaseDialog
    },

    data: () => ({
        type: 'edit',
        detail: {},
        dialog: false,
    }),

    mounted () {
        this.formInit = {...this.form}
    },

    methods: {
        hide () {
            this.dialog = false
        },
        processForm () {
            this.$emit('complete', this.form)
        },
        show () {
            this.dialog = true
            if (this.type === 'edit') {
                for (const key in this.formInit) {
                    this.form[key] = this.detail[key]
                }
            } else {
                for (const key in this.formInit) {
                    this.form[key] = this.formInit[key]
                }
            }
            this.postShow()
        },
        postShow() {
            // should be overriden
        }

    }
}
